// Utilities
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { createPersistedState } from 'pinia-plugin-persistedstate'
import SecureLS from 'secure-ls'

// secure storage
const ls = new SecureLS({ isCompression: false })
const secureStorage = {
  getItem(key: string): string | null {
    return ls.get(key)
  },
  setItem(key: string, value: string): void {
    ls.set(key, value)
  },
  removeItem(key: string): void {
    ls.remove(key)
  },
}

// Pinia 플러그인 설정
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
pinia.use(
  createPersistedState({
    storage: secureStorage,
    auto: true,
  }),
)

export default pinia

// Re-export all stores
export { useAppStore } from './modules/app'
export { useAccountStore } from './modules/account'
export { useUserStore } from './modules/users'
export { useMenuStore } from './modules/menu'
export { useDataDetailCacheStore } from './modules/dataDetailCache'
export { useProjectDetailCacheStore } from './modules/projectDetailCache'
export { useSessionDetailCacheStore } from './modules/sessionDetailCache'
export { useLookupListStore } from './modules/lookupList'
export { useHomeSearchCacheStore } from './modules/homeSearchCache'
export { useDownloadStore } from './modules/download'
